import { render } from "./MainFairPrice.vue?vue&type=template&id=3bf5ba3b&scoped=true"
import script from "./MainFairPrice.vue?vue&type=script&lang=js"
export * from "./MainFairPrice.vue?vue&type=script&lang=js"

import "./MainFairPrice.vue?vue&type=style&index=0&id=3bf5ba3b&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf5ba3b"]])

export default __exports__